<template>
  <section class="partner-section">

    <div class="container">

      <div class="header">

        <h1>
          Devenir partenaire
        </h1>

        <p>
          Rejoignez HayMiutyun et participez à la construction d'un réseau
          solidaire qui rassemble la communauté arménienne autour de l'entraide,
          du partage et de projets communs.
        </p>

      </div>


      <div class="intro-card">

        <div class="intro-icon">
          +
        </div>

        <div>

          <h2>
            Pourquoi devenir partenaire ?
          </h2>

          <p>
            En collaborant avec HayMiutyun, vous contribuez à développer
            des initiatives utiles pour la communauté et à toucher davantage
            de personnes ayant besoin d'accompagnement.
          </p>

          <p>
            Ensemble, nous pouvons créer des projets plus ambitieux,
            partager nos compétences et renforcer les liens entre les acteurs
            de la communauté arménienne.
          </p>

        </div>

      </div>


      <h2 class="section-title">
        Qui peut devenir partenaire ?
      </h2>


      <div class="partner-types">


     <div class="type-card">

  <div class="icon">
    <Landmark />
  </div>

  <h3>
    Associations
  </h3>

  <p>
    Développez des projets communs, partagez vos actions et bénéficiez
    d'un réseau plus large.
  </p>

</div>



<div class="type-card">

  <div class="icon">
    <Building2 />
  </div>

  <h3>
    Entreprises
  </h3>

  <p>
    Soutenez des initiatives solidaires et participez à des projets
    ayant un impact positif.
  </p>

</div>



<div class="type-card">

  <div class="icon">
    <UserRoundCheck />
  </div>

  <h3>
    Membres engagés
  </h3>

  <p>
    Apportez vos compétences, vos idées ou votre expérience pour aider
    notre communauté.
  </p>

</div>


      </div>



     <div class="advantages">

  <h2>
    Ce que nous construisons ensemble
  </h2>


  <div class="advantage-grid">


    <div>
      <span class="advantage-icon">
        <Network />
      </span>
      Développer notre réseau
    </div>


    <div>
      <span class="advantage-icon">
        <Handshake />
      </span>
      Créer des collaborations
    </div>


    <div>
      <span class="advantage-icon">
        <Heart />
      </span>
      Avoir un impact humain
    </div>


    <div>
      <span class="advantage-icon">
        <Rocket />
      </span>
      Lancer de nouveaux projets
    </div>


  </div>

</div>



      <div class="form-card">

        <h2>
          Proposer un partenariat
        </h2>

        <p>
          Présentez-nous votre structure et expliquons ensemble comment
          nous pouvons collaborer.
        </p>


        <form>


          <div class="row">

            <input
              type="text"
              placeholder="Nom de votre structure"
            />


            <input
              type="email"
              placeholder="Adresse email"
            />

          </div>


          <input
            type="text"
            placeholder="Type de partenariat (Association, entreprise...)"
          />


          <textarea
            rows="5"
            placeholder="Décrivez votre projet ou votre idée de collaboration..."
          ></textarea>


          <button>
            Envoyer ma demande
          </button>


        </form>

      </div>


    </div>

  </section>
</template>

<script setup>
import {
  Landmark,
  Building2,
  UserRoundCheck,
  Network,
  Handshake,
  Heart,
  Rocket
} from "lucide-vue-next"
</script>

<style scoped>

*{
  box-sizing:border-box
}

.partner-section{
  padding:40px 20px;
  background:linear-gradient(180deg,#fff,#f7f8fc)
}

.container{
  max-width:1200px;
  width:100%;
  margin:auto
}

.header{
  text-align:center;
  margin-bottom:50px
}

.header h1{
  font-size:48px;
  font-weight:800;
  margin:0 0 15px;
  background:linear-gradient(90deg,#D90012,#0033A0,#F2A800);
  -webkit-background-clip:text;
  color:transparent
}

.header p{
  max-width:800px;
  margin:auto;
  color:#666;
  font-size:18px;
  line-height:1.8
}


.intro-card{
  display:flex;
  align-items:center;
  gap:35px;
  background:white;
  padding:35px;
  border-radius:30px;
  box-shadow:0 20px 50px rgba(0,0,0,.08);
  border-left:5px solid #D90012;
  margin-bottom:60px
}


.intro-icon{
  width:75px;
  height:75px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:25px;
  background:linear-gradient(135deg,#8b0008,#D90012 45%,#0033A0);
  color:white;
  font-size:35px;
  font-weight:bold;
  flex-shrink:0
}


.intro-card h2{
  font-size:32px;
  margin:0 0 15px
}

.intro-card p{
  color:#666;
  line-height:1.8
}


.section-title{
  text-align:center;
  font-size:32px;
  margin-bottom:35px
}


.partner-types{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:25px;
  margin-bottom:60px
}


.type-card{
  background:white;
  padding:30px;
  border-radius:25px;
  text-align:center;
  box-shadow:0 10px 30px rgba(0,0,0,.07);
  transition:.3s;
  border-top:4px solid transparent
}


.type-card:nth-child(1){
  border-color:#D90012
}

.type-card:nth-child(2){
  border-color:#0033A0
}

.type-card:nth-child(3){
  border-color:#F2A800
}


.type-card:hover{
  transform:translateY(-8px)
}


.icon{
  width:60px;
  height:60px;
  margin:0 auto 20px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:20px;
  background:#fff1f2;
  color:#D90012;
  font-size:28px;
  font-weight:bold
}


.type-card h3{
  font-size:22px
}


.type-card p{
  color:#666;
  line-height:1.7
}


.advantages{
  background:white;
  padding:35px;
  border-radius:30px;
  text-align:center;
  box-shadow:0 10px 30px rgba(0,0,0,.06);
  margin-bottom:60px
}


.advantages h2{
  font-size:32px
}


.advantage-grid{
  display:grid;
  grid-template-columns:repeat(4,1fr);
  gap:20px;
  margin-top:30px
}


.advantage-grid div{
  padding:25px 15px;
  background:#f8f8f8;
  border-radius:20px;
  font-size:15px;
  font-weight:600
}


.advantage-icon{
  display:flex;
  align-items:center;
  justify-content:center;
  width:45px;
  height:45px;
  margin:0 auto 15px;
  border-radius:50%;
  background:#fff1f2;
  color:#D90012;
  font-size:22px
}


.form-card{
  background:white;
  padding:40px;
  border-radius:30px;
  box-shadow:0 20px 50px rgba(0,0,0,.08);
  text-align:center
}


.form-card h2{
  font-size:32px
}


.form-card p{
  color:#666;
  margin-bottom:30px
}


form{
  display:flex;
  flex-direction:column;
  gap:18px
}


.row{
  display:grid;
  grid-template-columns:repeat(2,1fr);
  gap:18px
}


input,
textarea{
  width:100%;
  padding:15px 18px;
  border-radius:15px;
  border:1px solid #ddd;
  font-size:16px;
  font-family:inherit;
  outline:none;
  transition:.3s
}


input:focus,
textarea:focus{
  border-color:#D90012;
  box-shadow:0 0 0 3px rgba(217,0,18,.1)
}


textarea{
  resize:none
}


button{
  padding:16px;
  border:none;
  border-radius:30px;
  background:linear-gradient(135deg,#8b0008,#D90012 45%,#0033A0);
  color:white;
  font-size:17px;
  font-weight:700;
  cursor:pointer;
  transition:.3s
}


button:hover{
  transform:translateY(-3px);
  box-shadow:0 10px 25px rgba(217,0,18,.25)
}


@media(max-width:900px){

  .partner-types,
  .advantage-grid{
    grid-template-columns:1fr
  }

  .row{
    grid-template-columns:1fr
  }

  .intro-card{
    flex-direction:column;
    text-align:center
  }

  .header h1{
    font-size:36px
  }

}


@media(max-width:480px){

  .partner-section{
    padding:25px 15px
  }

  .header h1{
    font-size:32px
  }

  .intro-card,
  .type-card,
  .advantages,
  .form-card{
    padding:25px 20px
  }

}

</style>